var _args = function (obj, offset) {
	return Array.prototype.slice.call(obj, offset || 0);
};

function CSearchSignals(
	/** ym.geo.CSearch */ searchObj,
	/**ym.map.CMap || ym.geo.CGeoRect */ areaObj,
	/** ym.event.CEventEmitter */ signalsObject
) {
	this.signalsObject = signalsObject;
	this.area = areaObj;
	this.search = searchObj;
}

CSearchSignals.prototype = {
	signalsObject: null,

	constructor: CSearchSignals,

	useCache: function () {
		var cached = this._cached;
		this.cache = {
			getCenter: function () {
				return cached.center;
			},
			getBoundingRect: function () {
				return cached.rect;
			}
		};
	},

	unuseCache: function () {
		this.cache = null;
	},

	_doSearch: function (method, args) {
		var self = this;

		self.signalsObject.emit.apply(self.signalsObject, ['searchbefore'].concat(args));
		args.unshift(function (data) {
			self.signalsObject.emit('searchsuccess', data);
		});
		self.search[method].apply(self.search, args);
	},

	_doSearchByAreaOrLocation: function (method, args) {
		var area = this.area;
		var cache = this.cache;

		if (!this.cache) {
			this._cached = {
				center: area.getCenter(),
				rect: area.getBoundingRect()
			};
		}

		args.unshift(cache ? cache : area);
		this._doSearch(method, args);
	},

	searchFulltext: function (branchCodes, searchTerm) {
		var fulltext = new ym.geo.CSearchFulltext(branchCodes);
		var self = this;
		fulltext.find(searchTerm, function (data) {
			self.signalsObject.emit('searchsuccess', data);
		});
	},

	searchInAreaByBranchCode: function (branchCodes, additions) {
		this._doSearchByAreaOrLocation('searchInAreaByBranchCode', _args(arguments, 0));
	},
	searchInAreaByCatchword: function (catchwords, additions) {
		this._doSearchByAreaOrLocation('searchInAreaByCatchword', _args(arguments, 0));
	},
	searchAtLocationByBranchCode: function (branchCodes, additions) {
		this._doSearchByAreaOrLocation('searchAtLocationByBranchCode', _args(arguments, 0));
	},
	searchAtLocationByCatchword: function (catchwords, additions) {
		this._doSearchByAreaOrLocation('searchAtLocationByCatchword', _args(arguments, 0));
	},
	searchAlongRouteByBranchCode: function (polyline, branchCodes, maxDistanceToRoute, corridorRouting, additions) {
		this._doSearch('searchAlongRouteByBranchCode', _args(arguments, 0));
	},
	lookupCluster: function (clusterID, clusterLevel, productTypes, additions) {
		this._doSearch('lookupCluster', _args(arguments, 0));
	},
	searchPhoneBookInArea: function (catchwords, additions) {
		this._doSearchByAreaOrLocation('searchPhoneBookInArea', _args(arguments, 0));
	},
	searchPhoneBookAtLocation: function (catchwords, additions) {
		this._doSearchByAreaOrLocation('searchPhoneBookAtLocation', _args(arguments, 0));
	},
	searchPhoneBookByNumber: function (phoneNumber, additions) {
		this._doSearch('searchPhoneBookByNumber', _args(arguments, 0));
	},
	searchEventInAreaByCatchword: function (catchwords, additions) {
		this._doSearchByAreaOrLocation('searchEventInAreaByCatchword', _args(arguments, 0));
	},
	searchEventInAreaByBranchCode: function (branchCodes, additions) {
		this._doSearchByAreaOrLocation('searchEventInAreaByBranchCode', _args(arguments, 0));
	},
	searchByCustomerIDs: function (customerID, additions) {
		this._doSearch('searchByCustomerIDs', _args(arguments, 0));
	},
	searchByIdentifier: function (identifier, additions) {
		this._doSearch('searchByIdentifier', _args(arguments, 0));
	},
	searchGeoLayer: function (geoLayer, additions) {
		this._doSearchByAreaOrLocation('searchGeoLayer', _args(arguments, 0));
	},
	searchBranchesCluster: function (clusterLevel, clusterID) {
		this._doSearch('searchBranchesCluster', _args(arguments, 0));
	}
};
